import React, {
  Component
} from 'react';

import {connect} from 'react-redux'
import MoodboardActions, {selectors} from '../redux/CarousselMoodboardRedux'
import TagManager from '../utils/tagManager'

class CarousselLauncher extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.proxy.querySelector('.image-container').addEventListener("click", () => this.openPopin())
    this.props.proxy.querySelector('.square-button-container .square-button').addEventListener("click", () => this.openPopin())
  }

  openPopin() {
    TagManager.pushEvent('clic-moodboard-picture-zoom', 'Contenu', 'Diaporama', this.props.proxy.querySelector('.image-container img').getAttribute('alt'));
    this.props.updateIndex(this.props.index);
    this.props.setVisible();
  }

  render() {
    return <div></div>
  }
}

const mapSelectors = (state) => {
  return {
    visible: selectors.visible(state),
  }
}

const mapActions = (dispatch) => {
  return {
    updateIndex: (index) => dispatch(MoodboardActions.moodboardUpdateIndex(index)),
    setVisible: () => dispatch(MoodboardActions.moodboardSetPopinVisible(true))
  }
}

export default connect(mapSelectors, mapActions)(CarousselLauncher)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/CarousselLauncher.js